import { useCurrentNavigation } from "@/features/common/dashboard/hooks/useCurrentNavigation"
import { useSession } from "@/lib/blueprint-auth/client"
import { type MenuItem } from "../types/menuItem"
import { useMenuItemsCollection } from "./useMenuItemCollection"

export function useDashboardMenu() {
    const menuItems = useMenuItemsCollection()

    const { data: session } = useSession()
    const { accountNumber, propertyId } = useCurrentNavigation()

    if (!session?.isAuthenticated || !accountNumber || !propertyId) {
        return []
    }

    return [
        {
            ...menuItems.account(accountNumber, propertyId),
            subMenu: [
                menuItems.payments(accountNumber, propertyId),
                menuItems.consumption(accountNumber, propertyId),
                menuItems.contracts(accountNumber, propertyId),
                menuItems.referral(accountNumber),
            ].filter(Boolean),
        },
    ] satisfies MenuItem[]
}

useDashboardMenu.messages = [...useMenuItemsCollection.messages] as const
